import React from 'react';
import {
  FileField,
} from '@components/FormFields';
import {
  VStack,
} from 'ui';
import { DocumentFileIcon } from '@assets/icons/DocumentFileIcon';
import { useController } from './hooks';
import { styles as s } from './FileUploader.styles';
import { AskForPassword } from './components';

export const FileUploader = ({
  name,
  label,
  accept,
  control,
  progress,
  labelText,
  clearField,
  onLoadFile,
  isDisabled,
  placeholder,
  isUploading,
  onSubmitFile,
  filesCount = 1,
  filesWithPassword,
  uploadingFieldName,
  askForPasswordInFiles,
  onRemoveFile: onRemoveFileProp,
  onSubmitWithPassword: onSubmitWithPasswordProp,
  ...props
}) => {
  const {
    fields,
  } = useController({
    name,
    control,
    clearField,
    onLoadFile,
    isDisabled,
    filesCount,
    isUploading,
    onSubmitFile,
    filesWithPassword,
    uploadingFieldName,
    askForPasswordInFiles,
    onRemoveFile: onRemoveFileProp,
    onSubmitWithPassword: onSubmitWithPasswordProp,
  });

  return (
    <VStack
      {...props}
      display={filesCount ? undefined : 'none'}
    >
      {fields?.map(({
        onChange,
        fileNames,
        fieldName,
        isHiddenField,
        isFieldDisabled,
      }) => (
        <FileField
          {...s.fileField}
          progress={progress}
          id="FileUploader.labelFor"
          accept={accept}
          labelText={labelText}
          iconElement={<DocumentFileIcon color="gray.500" />}
          data-testid={fieldName}
          name={fieldName}
          control={control}
          onChange={onChange}
          placeholder={fileNames || placeholder}
          isDisabled={isFieldDisabled}
          key={`${fieldName}-field`}
          display={isHiddenField ? 'none' : 'block'}
        />
      ))}
      {fields?.map((alertProps) => (
        alertProps.displayAskForPassword
          ? (
            <AskForPassword
              key={alertProps.fieldName}
              control={control}
              marginTop="2"
              status={alertProps.status}
              fileNames={alertProps.fileNames}
              fieldName={alertProps.fieldName}
              onRemoveFile={alertProps.onRemoveFile}
              isAlertLoading={alertProps.isAlertLoading}
              onSubmitWithPassword={alertProps.onSubmitWithPassword}
            />
          )
          : null
      ))}
    </VStack>
  );
};
